import { Pipe, PipeTransform } from '@angular/core';
import { MapLocation } from './map-picker.component';

@Pipe({
  name: 'latLonToPoint'
})
export class LatLonToPointPipe implements PipeTransform {

    transform(lat: number | { lat?: number, lon?: number }, lon?: number): MapLocation {
        if (!lat) return null;
        if (typeof lat === 'object') return {lat: lat.lat, lng: lat.lon};
        return {lat: lat, lng: lon};
    }

}
